import "./App.css";

import Home from "./Components/Pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./CommonJquery/ScrollToTop";
import KundaliPage from "./Components/Pages/KundaliPage";
import DailyPrediction from "./Components/Section/DailyPrediction";
import ExpertPage from "./Components/Pages/ExpertPage";
import Forum from "./Components/Pages/Forum";
import KundaliMatching from "./Components/Pages/KundaliMatching";
import MarriageRelationship from "./Components/Pages/MarriageRelationship";
import PersonalizedReading from "./Components/Pages/PersonalizedReading";
import KundaliDetails from "./Components/Pages/KundaliDetails";
import ShubhMahurat from "./Components/Pages/ShubhMahurat";
import ForumQuestions from "./Components/Pages/ForumQuestions";
import PageNotFound from "./Components/Pages/PageNotFound";
import Profile from "./Components/Pages/Profile";
import AskQuestion from "./Components/Pages/AskQuestion";
import OurPhilosophy from "./Components/Pages/OurPhilosophy";
import TermsCondition from "./Components/Pages/TermsCondition";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import SuccessPage from "./Components/Pages/SuccessPage"
import MyReplies from "./Components/Pages/MyReplies";
import MyQuestions from "./Components/Pages/MyQuestions";
import MyPayments from "./Components/Pages/MyPayments";
import Support from "./Components/Pages/Support";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kundli" element={<KundaliPage />} />
          <Route path="/daily" element={<DailyPrediction />} />
          <Route path="/experts" element={<ExpertPage />} />
          <Route path="/forum" element={<Forum />} />
          <Route
            path="/kundli-matching"
            element={<KundaliMatching page_name="Marriage" />}
          />
          <Route
            path="/marriage-relationship-consultation"
            element={<MarriageRelationship page_name="Marriage" />}
          />
          <Route
            path="/personalized-reading"
            element={
              <PersonalizedReading
                page_name="Personalized Reading"
                page_details="Get customized astrological guidance tailored to your goals"
                click_from="0"
              />
            }
          />
          <Route
            path="/experts/astrology-reading/:id/:id2"
            element={
              <PersonalizedReading
                page_name="Ask Experts"
                page_details="Get clear, personalized answers based on your unique astrological profile"
                click_from="4"
              />
            }
          />

          <Route
            path="/kundli/kundli-details/:id/:id2"
            element={
              <KundaliDetails click_from="1" page_name="Kundli Creation" />
            }
          />
          <Route
            path="/kundli-matching/kundli-details/:id/:id2"
            element={
              <KundaliDetails click_from="2" page_name="Kundli Creation" />
            }
          />

          <Route path="/shubh-muhurat" element={<ShubhMahurat />} />
          <Route path="/forum-questions/:id" element={<ForumQuestions />} />
          <Route
            path="/kundli-form/kundli-details/:id/:id2"
            element={<KundaliDetails click_from="3" page_name="Thread" />}
          />
          <Route path="/profile" element={<Profile />} />
          <Route path="/ask-question" element={<AskQuestion />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/failure" element={<SuccessPage />} />
          <Route path="/our-philosophy" element={<OurPhilosophy />} />
          <Route path="/terms-and-conditions" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/my-replies" element={<MyReplies />} />
          <Route path="/my-questions" element={<MyQuestions />} />
          <Route path="/my-payments" element={<MyPayments />} />
          <Route path="/support" element={<Support />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
